/* ==========================================================================
   pdp.js
   자사몰(D2C) 상품 페이지 "구매 영역"(sections/pdp-hero.liquid 의 purchase 블록) 동작.

   - 옵션 선택 → 변형(variant) 찾기 → 가격 · 품절 · 주소(?variant=) 갱신
   - 수량 +/-
   - 장바구니 담기: /cart/add.js 로 AJAX 추가 후 Horizon 이 쓰는 'cart:update' 이벤트를
     내보내 장바구니 서랍·헤더 수량이 그대로 갱신되게 함. 서랍이 없는 설정(page 방식)이면
     /cart 로 이동.
   - 바로 구매(Shop Pay 등 payment_button)는 Shopify 기본 동작을 그대로 둠(가로채지 않음).

   Amazon 추적(amazon-bridge.js 의 data-amz-cta)은 이 페이지에 없으므로 발생하지 않음.
   같은 파일이 여러 번 로드돼도 1회만 실행됨.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__pdpLoaded) return;
  window.__pdpLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initBuy(buy) {
    if (buy.__pdpInit) return;
    buy.__pdpInit = true;

    var form = buy.querySelector('form');
    if (!form) return;

    var root = buy.closest('[data-pdp-root]') || document;
    var idInput = form.querySelector('[data-pdp-variant-id]');
    var addBtn = form.querySelector('[data-pdp-add]');
    var buyNow = form.querySelector('[data-pdp-buy-now]');
    var buyNowText = form.querySelector('[data-pdp-buy-now-text]');
    var addText = form.querySelector('[data-pdp-add-text]');
    var errorEl = form.querySelector('[data-pdp-error]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var express = form.querySelector('[data-pdp-express]');
    var groups = form.querySelectorAll('[data-pdp-option]');
    var stickyAdd = root.querySelector('[data-pdp-sticky-add]');
    var stickyAddText = root.querySelector('[data-pdp-sticky-add-text]');
    var stickyVariantId = root.querySelector('[data-pdp-sticky-variant-id]');
    var stickyQty = root.querySelector('[data-pdp-sticky-qty]');
    var stickyExpress = root.querySelector('[data-pdp-sticky-express]');
    var stickySoldOut = root.querySelector('[data-pdp-sticky-soldout]');

    var variants = [];
    var jsonEl = buy.querySelector('[data-pdp-variants]');
    try {
      variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]');
    } catch (e) {
      variants = [];
    }

    var labelAdd = addBtn ? addBtn.getAttribute('data-label-add') || 'Add to cart' : 'Add to cart';
    var labelSoldOut = addBtn ? addBtn.getAttribute('data-label-sold-out') || 'Sold out' : 'Sold out';
    var labelBuyNow = buyNow ? buyNow.getAttribute('data-label-buy-now') || 'Buy now' : 'Buy now';
    var stickyLabel = stickyAddText ? stickyAddText.textContent.trim() || labelAdd : labelAdd;
    var busy = false;
    var goCheckout = false;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    /* ---------- 옵션 → 변형 ---------- */
    function optionsOf(v) {
      if (Array.isArray(v.options)) return v.options;
      return [v.option1, v.option2, v.option3].filter(function (o) {
        return o !== null && o !== undefined;
      });
    }

    function findVariant() {
      var chosen = Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      for (var i = 0; i < variants.length; i++) {
        var opts = optionsOf(variants[i]);
        var match = true;
        for (var j = 0; j < chosen.length; j++) {
          if (opts[j] !== chosen[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function setText(selector, text) {
      var el = root.querySelector(selector);
      if (el) el.textContent = text;
    }

    function setHidden(selector, hidden) {
      var el = root.querySelector(selector);
      if (el) el.hidden = hidden;
    }

    function applyVariant(v) {
      hideError();

      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (express) express.hidden = true;
        return;
      }

      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));

      setText('[data-pdp-price]', money(v.price));
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var pct = onSale ? Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
      setHidden('[data-pdp-compare]', !onSale);
      setHidden('[data-pdp-percent]', !onSale);
      if (onSale) {
        setText('[data-pdp-compare]', money(v.compare_at_price));
        setText('[data-pdp-percent]', '-' + pct + '%');
      }

      if (stickyVariantId) {
        stickyVariantId.value = v.id;
        stickyVariantId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (stickyExpress) stickyExpress.hidden = !v.available;
      if (stickySoldOut) stickySoldOut.hidden = v.available;
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (stickyAddText) stickyAddText.textContent = v.available ? stickyLabel : labelSoldOut;

      if (buyNow) buyNow.disabled = !v.available;
      if (buyNowText) buyNowText.textContent = v.available ? labelBuyNow : labelSoldOut;
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? labelAdd : labelSoldOut;
      if (express) express.hidden = !v.available;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(null, '', url.toString());
      } catch (e) {
        /* 주소 갱신 실패는 무시 */
      }
    }

    if (groups.length) {
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('.pdp-opt__input')) {
          applyVariant(findVariant());
        }
      });
    }

    /* ---------- 수량 ---------- */
    function clampQty(n) {
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function syncStickyQty() {
      if (stickyQty && qtyInput) stickyQty.value = clampQty(parseInt(qtyInput.value, 10));
    }

    var minus = form.querySelector('[data-pdp-qty-minus]');
    var plus = form.querySelector('[data-pdp-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () {
        qtyInput.value = clampQty(parseInt(qtyInput.value, 10) - 1);
        syncStickyQty();
      });
      plus.addEventListener('click', function () {
        qtyInput.value = clampQty(parseInt(qtyInput.value, 10) + 1);
        syncStickyQty();
      });
      qtyInput.addEventListener('change', function () {
        qtyInput.value = clampQty(parseInt(qtyInput.value, 10));
        syncStickyQty();
      });
    }

    /* ---------- 장바구니 담기 ---------- */
    function notifyCart(cart, sections, quantity) {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) {
        window.location.href = ROOT + 'cart';
        return;
      }
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: cart,
        sourceId: form.id,
        data: {
          source: 'product-form-component',
          itemCount: quantity,
          productId: buy.getAttribute('data-product-id'),
          sections: sections
        }
      };
      form.dispatchEvent(ev);
    }

    async function addToCart() {
      var quantity = clampQty(parseInt(qtyInput ? qtyInput.value : '1', 10));
      var data = new FormData(form);

      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });
      if (sectionIds.length) data.append('sections', sectionIds.join(','));

      var res;
      var body;
      try {
        res = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        body = await res.json();
      } catch (err) {
        // 네트워크 오류 — 일반 폼 전송으로 대체(장바구니 페이지로 이동)
        form.submit();
        return;
      }

      if (!res.ok || body.status) {
        showError(body.description || body.message || 'Could not add this item to your cart.');
        return;
      }

      try {
        var cartRes = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
        var cart = await cartRes.json();
        if (goCheckout) {
          window.location.href = ROOT + 'checkout';
          return;
        }
        notifyCart(cart, body.sections, quantity);
      } catch (err) {
        // 추가는 이미 성공 — 서랍 갱신만 실패한 경우라 장바구니 페이지로 보냄(중복 추가 방지)
        window.location.href = ROOT + 'cart';
      }
    }

    /* ---------- 따라다니는 구매 바 ---------- */
    var sticky = root.querySelector('[data-pdp-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          // 메인 버튼이 화면 위쪽으로 지나간 경우에만 표시(아래에 있을 땐 숨김)
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
          // 구매 바가 푸터 내용을 가리지 않게 본문 아래 여백 확보
          document.body.style.paddingBottom = show ? sticky.offsetHeight + 40 + 'px' : '';
        },
        { threshold: 0 }
      );
      stickyObserver.observe(buyNow || addBtn);
    }

    if (stickyAdd && addBtn) {
      stickyAdd.addEventListener('click', function () {
        // 바로 구매 모드면 담은 뒤 결제 화면으로 이동
        goCheckout = stickyAdd.hasAttribute('data-pdp-sticky-checkout');
        addBtn.click();
      });
    }

    if (buyNow && addBtn) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled) return;
        // 담은 뒤 결제 페이지로 이동
        goCheckout = true;
        addBtn.click();
      });
    }

    form.addEventListener('submit', function (e) {
      // 바로 구매(payment_button)처럼 다른 버튼으로 제출된 경우는 Shopify 기본 동작에 맡김
      if (e.submitter && e.submitter !== addBtn) return;

      e.preventDefault();
      if (busy || (addBtn && addBtn.disabled)) {
        goCheckout = false;
        return;
      }

      busy = true;
      hideError();
      if (addBtn) {
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.classList.add('is-loading');
      }
      if (stickyAdd) stickyAdd.classList.add('is-loading');
      if (buyNow) buyNow.classList.add('is-loading');

      addToCart().then(function () {
        busy = false;
        if (addBtn) {
          addBtn.removeAttribute('aria-busy');
          addBtn.classList.remove('is-loading');
        }
        if (stickyAdd) stickyAdd.classList.remove('is-loading');
        if (buyNow) buyNow.classList.remove('is-loading');
        goCheckout = false;
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pdp-buy]').forEach(initBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 테마 에디터에서 섹션이 다시 그려질 때 새로 생긴 구매 영역을 초기화
  document.addEventListener('shopify:section:load', boot);
})();
